import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-modal-info',
  standalone: false,
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.scss']
})
export class ModalInfoComponent implements OnInit {

  @Input() title: string;
  @Input() content: string;
  @Input() decisionMode = false;
  @Input() confirmButtonText = 'Confirm';
  @Input() secondOptionText: string;
  @Input() cancelButtonText = 'Cancel';

  @Output() action: EventEmitter<string> = new EventEmitter<string>();

  constructor(    public modalRef: MDBModalRef,
    ) { }

  ngOnInit(): void {
  }

  onConfirm(): void {
    this.action.emit('confirm');
    this.modalRef.hide();
  }

  onCancel(): void {
    this.action.emit('cancel');
    this.modalRef.hide();
  }
  
  onSecondConfirm(): void {
    this.action.emit('secondConfirm');
    this.modalRef.hide();
  }

  onClose(): void {
    this.modalRef.hide();
  }

}
